import { Button, Flex, Image, Input, Spinner, Text } from "@chakra-ui/react";
import { GRAY, VARIANT, WHITE } from "../constants/colors";
import "react-credit-cards-2/es/styles-compiled.css";
import { useEffect, useState } from "react";
import useScript from "./helpers/useScript";
import { toast } from "react-toastify";
import ModalPaymentConfirmation from "./components/ModalPaymentConfirmation";
import axios from "axios";
import { baseURL } from "../services/api";
import Qrcode from "qrcode.react";
import copy from "copy-to-clipboard";
import TitleFlex from "../pages/vendas/vendasBoleto/components/titleFlex";
import { useMediaQuery, MediaQuery } from 'react-responsive'

export default function PixPayment() {
  useScript(
    null,
    `(function (a, b, c, d, e, f, g) {
    a['CsdpObject'] = e; a[e] = a[e] ||  function () {
    (a[e].q = a[e].q || []).push(arguments)
  }, a[e].l = 1 * new Date(); f = b.createElement(c),
  g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g)
})(window, document, 'script', 'https://device.clearsale.com.br/p/fp.js', 'csdp');
  csdp('app', '7gaq6iqa70lrxje431t6');
  csdp('outputsessionid', 'sessionId');`
  );

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  
  const initialState = {
    ip: "",
    sessionID: "",
    cpfPagador: "",
    telefonePagador: "",
    dataNascPagador: "",
    enderCEP: "",
    enderRua: "",
    enderNumero: "",
    enderComplemento: "",
    enderReferencia: "",
    enderBairro: "",
    enderCidade: "",
    enderEstado: "AC",
  };

  const [objeto, setObjeto] = useState(initialState);

  const unMask = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  const [isOpen, setIsOpen] = useState(false);

  function handleCallback({ issuer }, isValid) {
    if (isValid) {
      setObjeto({ ...objeto, bandeira: issuer });
    }
  }

  const token = window.location.search.slice(7);

  const [pagador, setpagador] = useState();

  async function getVendaDigitadaPerToken() {
    try {
      const response = await axios.get(
        `${baseURL}/buscarVenda-digitada/token?token=${token}`
      );
      setpagador(response.data);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getVendaDigitadaPerToken();
  }, []);

  const [pix, setPix] = useState();
  const [loading, setLoading] = useState(false);
  async function postVendaPix() {
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseURL}/PagamentoDigitada/Pix?token=${token}`
      );
      setPix(response.data);
      console.log("response do post pix pagamento", response.data);
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível validar o pagamento com PIX!");
    }
  }

  return (
    <Flex
      w={"99.9vw"}
      h={isMobile ? "fit-content" : "99.6vh"}
      bgColor={GRAY}
      flexDir={isMobile ? "column" : "row"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Flex
        w={"70vw"}
        h={isMobile ? "fit-content" : "95vh"}
        flexDir={"column"}
        bgColor={WHITE}
        borderRadius={"20px"}
      >
        <Flex w={"100%"} h={"8%"} justifyContent={"center"}>
          <Image src={"./logo.png"} />
        </Flex>
        <Flex
          w={"100%"}
          h={"70%"}
          flexDir={isMobile ? "column" : "row"} // <--------------------
          justifyContent={"space-evenly"}
          alignItems={"center"}

        >
          <Flex w={"62%"} h={"100%"} flexDir={"column"}>
            <Flex justifyContent={"center"} px={4}>
              <Input type="hidden" id="sessionId" />
              <Image maxHeight={"300px"} src={"./logo-pix.png"} />
            </Flex>
            {
              isMobile ?
              <Flex
                w={"100%"}
                h={"95%"}
                flexDir={"column"}
                textAlign={"left"}
              >
                <TitleFlex item={"Cliente"} />
                <Flex flexDir={"column"} justifyContent="center" alignItems={"flex-start"} pl={4}>
                  <Text fontWeight={"bold"}>{pagador && pagador.nomePagador}</Text>
                  <Text>{pagador && pagador.emailPagador}</Text>
                </Flex>
                <TitleFlex item={"Detalhes da Compra"} />
                {pagador && pagador.itens ? (
                  pagador.itens.map((item, index) => {
                    return (
                      <Flex
                        
                        flexDir={"column"} justifyContent="center" alignItems={"flex-start"} pl={4}
                        key={index}
                        my={2}
                        // justifyContent={"space-between"}
                      >
                        <Flex flexDir={"column"} w={"80%"}>
                          <Text fontWeight={"bold"}>
                            {item.codigo != ""
                              ? `${item.codigo} - ${item.descricao}`
                              : item.descricao}
                          </Text>
                          <Text>{`Quantidade : ${item.quantidade}`}</Text>
                          <Text>{`Valor do Item : ${item.valorItem.toLocaleString(
                            "pt-BR",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )}`}</Text>
                        </Flex>
                        <Flex alignItems={"center"}>
                          <Text
                            fontWeight={"bold"}
                            fontSize={"20px"}
                            color={VARIANT}
                          >
                            {item.valorTotalItem.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Text>
                        </Flex>
                      </Flex>
                    );
                  })
                ) : (
                  <></>
                )}
                <TitleFlex item={"Total"} />
                <Flex flexDir={"column"} justifyContent="center" alignItems={"flex-start"} pl={4}>
                  <Text fontWeight={"bold"} fontSize={"24px"} color={VARIANT}>
                    {pagador &&
                      pagador.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                  </Text>
                </Flex>
              </Flex>
              :
              <></>
            }
            {loading === false ? (
              <>
                {pix && pix.barcode ? (
                  <Flex
                    flexDir={"column"}
                    w={"100%"}
                    alignItems={"center"}
                    h={"fit-content"}
                  >
                    <Text mb={6} fontSize={"18px"}>
                      Leia o QR Code abaixo para realizar o pagamento:
                    </Text>
                    <Qrcode value={pix.barcode} />
                    <Button
                      mt={4}
                      bgColor={VARIANT}
                      color={WHITE}
                      onClick={() => copy(pix.barcode)}
                    >
                      Copiar Código do PIX
                    </Button>
                    <Text mt={6} fontSize={"18px"}>
                      Este Código QR é válido por apenas 5 minutos.
                    </Text>
                  </Flex>
                ) : (
                  <>
                    <Flex justifyContent={"center"} px={4} mt={isMobile ? 4 : "0"}>
                      <Text
                        fontWeight={"bold"}
                        fontSize={"24px"}
                        color={VARIANT}
                        w={"100%"}
                      >
                        {pagador &&
                          `Confirmar o pagamento de
                          ${pagador.valorTotal.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })} por PIX?`}
                      </Text>
                    </Flex>
                    <Flex justifyContent={"center"} w={"100%"} mb={isMobile ? 6 : "0"}>
                      <Button
                        bgColor={VARIANT}
                        color={WHITE}
                        mt={4}
                        w={"600px"}
                        onClick={() => {
                          postVendaPix();
                        }}
                      >
                        Confirmar
                      </Button>
                    </Flex>
                  </>
                )}
              </>
            ) : (
              <Flex w={"100%"} justifyContent={"center"}>
                <Spinner size="lg" color={VARIANT} />
              </Flex>
            )}
          </Flex>
          { 
            !isMobile ? 
              <Flex
                w={"35%"}
                maxWidth={"35%"}
                h={"95%"}
                borderLeft={`solid 4px ${VARIANT}`}
                flexDir={"column"}
              >
                <TitleFlex item={"Cliente"} />
                <Flex flexDir={"column"} px={4}>
                  <Text fontWeight={"bold"}>{pagador && pagador.nomePagador}</Text>
                  <Text>{pagador && pagador.emailPagador}</Text>
                </Flex>
                <TitleFlex item={"Detalhes da Compra"} />
                {pagador && pagador.itens ? (
                  pagador.itens.map((item, index) => {
                    return (
                      <Flex
                        flexDir={"row"}
                        px={6}
                        key={index}
                        my={2}
                        justifyContent={"space-between"}
                      >
                        <Flex flexDir={"column"} w={"80%"}>
                          <Text fontWeight={"bold"}>
                            {item.codigo != ""
                              ? `${item.codigo} - ${item.descricao}`
                              : item.descricao}
                          </Text>
                          <Text>{`Quantidade : ${item.quantidade}`}</Text>
                          <Text>{`Valor do Item : ${item.valorItem.toLocaleString(
                            "pt-BR",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )}`}</Text>
                        </Flex>
                        <Flex alignItems={"center"}>
                          <Text
                            fontWeight={"bold"}
                            fontSize={"20px"}
                            color={VARIANT}
                          >
                            {item.valorTotalItem.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Text>
                        </Flex>
                      </Flex>
                    );
                  })
                ) : (
                  <></>
                )}
                <TitleFlex item={"Total"} />
                <Flex justifyContent={"flex-end"} px={4}>
                  <Text fontWeight={"bold"} fontSize={"24px"} color={VARIANT}>
                    {pagador &&
                      pagador.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                  </Text>
                </Flex>
              </Flex>
              :
              <></>
          }
        </Flex>
        <ModalPaymentConfirmation isOpen={isOpen} setIsOpen={setIsOpen} />
      </Flex>
    </Flex>
  );
}
